import { render, staticRenderFns } from "./PriceCurrencySelection.vue?vue&type=template&id=0c68ef2a&scoped=true"
import script from "./PriceCurrencySelection.vue?vue&type=script&lang=js"
export * from "./PriceCurrencySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68ef2a",
  null
  
)

export default component.exports